import React from 'react'
import ReactDOM from 'react-dom'

require('../css/venuePage.css')


export default class Player extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      loaded: false
    }
  }
  componentDidMount(){
    window.Player.start(ReactDOM.findDOMNode(this), this.props.config , () => {
      this.setState({loaded: true})
      this.props.isReady(window.Player)
    })
  }
  render(){
    return(<div id="ss-player"></div>)
  }
}

Player.propTypes =  {
  config: React.PropTypes.object.isRequired,
  isReady: React.PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/Player.jsx